export default "__VITE_ASSET__B6IcX3UT__"